import { User, VenueGetUserFilter } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

const venueGetUserPictureQuery = /* GraphQL */ `
  query VenueGetUser($filter: VenueGetUserFilter!) {
    venueGetUser(filter: $filter) {
      id
      firstname
      lastname
      picture {
        thumbnail
        small
        medium
      }
    }
  }
`;

export const venueGetUserPictureApi = async (filter: VenueGetUserFilter): Promise<User> => {
  const result = await executeGql<User>(venueGetUserPictureQuery, { filter });
  return processGqlResult<User>('venueGetUser', result);
};
